import { action, reaction, computed, observable } from 'mobx';
import { IWarehouse, IWarehouseApi, IWarehouseStock, IWarehouseLocationDetails } from '../../../common/interfaces/warehouse';
import { app } from '../App';
import { user, cart } from './AllStores';

export class Warehouse {
    private reactToUserLogin = reaction(
        () => user.isLoggedIn,
        loggedIn => {
            if (loggedIn) {
                this.fetchWarehouses();
                this.fetchWarehousesLocations();
            }
        }
    );

    @observable public warehouses: IWarehouse[] = [];

    @observable public customerPickupWarehouses: IWarehouseStock[] = [];

    private californiaWarehousesCodes: string[] = ['P2', 'P3', 'P4', 'P5', 'PA', 'PB'];

    @computed
    public get californiaWarehouses(): IWarehouse[] {
        return this.warehouses.filter(whs => this.californiaWarehousesCodes.indexOf(whs.whsCode) !== -1);
    }

    @computed
    public get otherThanCaliforniaWarehouses(): IWarehouse[] {
        return this.warehouses.filter(whs => this.californiaWarehousesCodes.indexOf(whs.whsCode) === -1);
    }

    // All customer warehouses
    @computed
    public get customerAvailableWarehouses(): IWarehouse[] {
        let whs = [];

        if (user.isLoggedIn && user.isCustomer) {
            if (user.customerIsPAC) {
                whs = this.californiaWarehouses;
            } else if (user.customerIsPBI) {
                whs = this.warehouses;
            }
        }

        return whs;
    }

    // Customer main warehouse
    @computed
    public get customerWarehouse(): IWarehouse {
        let customerWarehouse: IWarehouse = {
            whsCode: 'PB',
            whsName: 'South El Monte'
        };

        if (user.isCustomer && user.customer.whscode && this.warehouses.length > 0) {
            this.warehouses.some(whs => {
                if (whs.whsCode === user.customer.whscode) {
                    customerWarehouse = whs;
                    return true;
                }
            });
        }

        return customerWarehouse;
    }

    // Recalculate warehouses availability of items in current cart
    @action
    public recalculateWarehousesItemsAvailability = async () => {
        const itemsInCartCount: number = cart.currentCart && cart.currentCart.item ? cart.currentCart.item.length : 0;

        this.customerPickupWarehouses = await this.customerAvailableWarehouses.map(whs => {
            let itemsInCartAvailableAtWarehouseCount: number = 0;

            if (cart.currentCart && cart.currentCart.item) {
                cart.currentCart.item.map(item => {
                    const warehouseItemStock: number =
                        typeof item.stock !== 'undefined' && !!item.stock[whs.whsCode] ? item.stock[whs.whsCode].stock : 0;

                    itemsInCartAvailableAtWarehouseCount += warehouseItemStock >= item.quantity ? 1 : 0;
                });
            }

            return {
                ...whs,
                whsAllCartItemsAvailable: itemsInCartAvailableAtWarehouseCount >= itemsInCartCount
            };
        });

        return true;
    };

    @action
    fetchWarehouses = async (): Promise<IWarehouse[]> => {
        try {
            const service = await app.service('warehouse');
            const results = (await service.find({
                query: {
                    $limit: 99999,
                    $skip: 0
                }
            })) as IWarehouseApi;

            this.warehouses = results.data;

            return results.data;
        } catch (err) {
            console.error(err);
            throw err;
        }
    };

    @observable public showWarehousesLocations: boolean = false;

    @observable public warehousesLocationsList: IWarehouseLocationDetails[] = [];

    @computed
    public get warehousesLocationsOfUserList(): IWarehouseLocationDetails[] {
        return this.warehousesLocationsList.filter(
            whs =>
                (user.customerIsPAC && whs.pac) ||
                (user.customerIsPBIRegular && whs.pbi) ||
                (user.customerIsPBIPlus && whs.pbiplus)
        );
    }

    @action
    fetchWarehousesLocations = async (): Promise<IWarehouseLocationDetails[]> => {
        try {
            const service = await app.service('warehouse-location');
            const results = (await service.find({})) as IWarehouseLocationDetails[];

            const list = results.map(whs => ({
                ...whs,
                pac: whs.pac ? true : false,
                pbi: whs.pbi ? true : false,
                pbiplus: whs.pbiplus ? true : false
            }));

            this.warehousesLocationsList = list;
            return list;
        } catch (err) {
            console.error(err);
            throw err;
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Warehouse.ts